import orderBy from 'lodash.orderby';
import { handleActions } from 'redux-actions';

import { apiSuccess } from '../apiStatus';
import { GET_AGENT_INPUTS_HISTORY } from '../types/training';

const initialState = {
  status: 'INIT',
  agentId: null,
  error: null,
  inputHistories: [],
  historyMetaInformation: null,
};

const transformInputsToHistory = (inputs) => {
  const histories = inputs.map((input) => {
    return {
      id: input.change_id,
      input_id: input.after_values.input_id,
      input_value: input.after_values?.input_value,
      block_match_id: input.before_values?.intent_id,
      trained_block_id: input.after_values?.intent_id,
      change_date: new Date(input.change_date),
      change_user_id: input.change_user_id,
    };
  });
  return orderBy(histories, 'change_date', 'desc');
};

export const trainingReducer = handleActions(
  {
    [apiSuccess(GET_AGENT_INPUTS_HISTORY)]: (
      state,
      { payload: { agent_id, data } }
    ) => {
      const historyMetaInformation = Object.assign({}, data);
      delete historyMetaInformation.content;

      return {
        ...state,
        agentId: agent_id,
        inputHistories: transformInputsToHistory(data.content),
        historyMetaInformation,
      };
    },
  },
  initialState
);
